@if (isBrowser()) {
  @if (isAtlas()) {
    @defer {
      <smart-atlas3 [slug]="contentSlug()" [options]="options()" [referenceID]="referenceId()" [id]="exportId"></smart-atlas3>
    }
  }

  @if (isDash()) {
    @defer {
      <smart-dash [slug]="contentSlug()" [options]="options()" [referenceID]="referenceId()" [id]="exportId"></smart-dash>
    }
  }

  @if (isReport()) {
    @defer {
      <smart-report [slug]="contentSlug()" [options]="options()" [referenceID]="referenceId()" [id]="exportId"></smart-report>
    }
  }

  @if (isChart()) {
    @defer {
      <smart-chart3 [slug]="contentSlug()" [options]="options()" [referenceID]="referenceId()" [id]="exportId"></smart-chart3>
    }
  }

  @if (isMap()) {
    @defer {
      <smart-map2 [slug]="contentSlug()" [options]="options()" [referenceID]="referenceId()" [id]="exportId"></smart-map2>
    }
  }

  @if (isTable()) {
    @defer {
      <smart-table [slug]="contentSlug()" [options]="options()" [referenceID]="referenceId()" [id]="exportId"></smart-table>
    }
  }

  @if (isDataSet()) {
    @defer {
      <smart-source [slug]="contentSlug()" [options]="options()" [referenceID]="referenceId()" [id]="exportId"></smart-source>
    }
  }
} @else {
  <div class="container flex min-w-full flex-1">
    <smart-ssr [slug]="slug()" [referenceID]="referenceId()"></smart-ssr>
  </div>
}
